import { PaymentAPI as o } from "../paymentApi.js";
import { PaymentProcessAPI as n } from "../paymentProcess.js";
class m extends n.PaymentProcess {
  constructor(e) {
    super({
      ...e,
      engine: o.PaymentMethodEngine.REDSYS
    });
  }
  afterInitialize(e) {
    return Promise.resolve();
  }
  updateEngineAmount(e) {
  }
  mount(e) {
    return Promise.resolve();
  }
  initialize() {
    return Promise.resolve();
  }
  submitRedsysForm(e) {
    const r = document.createElement("form");
    r.method = e.method, r.action = e.url, r.style.display = "none", Object.entries(e.fields).forEach(([t, a]) => {
      const s = document.createElement("input");
      s.type = "hidden", s.name = t, s.value = a, r.appendChild(s);
    }), document.body.appendChild(r), r.submit();
  }
  async executePayment(e) {
    const r = new URL(window.location.href);
    r.searchParams.delete("Ds_Signature"), r.searchParams.delete("Ds_SignatureVersion"), r.searchParams.delete("Ds_MerchantParameters"), r.searchParams.set(o.REDIRECT_ENGINE_PARAM_ORDER_ID, e.orderId), e.wsUuid && r.searchParams.set(o.REDIRECT_ENGINE_PARAM_WS_ID, e.wsUuid), r.searchParams.set(
      o.REDIRECT_ENGINE_PARAM_ENGINE,
      String(this.configuration.engine)
    );
    const t = await this.paymentRepository.redsysCheckout({
      orderId: e.orderId,
      amount: this.configuration.amount,
      cashback: this.configuration.cashback,
      tip: this.configuration.tip,
      currency: this.configuration.currency,
      locationId: this.configuration.locationId,
      returnUrl: r.toString(),
      email: e.email,
      externalUserId: e.externalUserId,
      countryCode: this.configuration.countryCode,
      actions: e.actions,
      wsUuid: e.wsUuid,
      selectedItems: e.selectedItems
    });
    return this.submitRedsysForm(t.action), {
      transactionId: t.transactionCode,
      code: t.transactionCode,
      action: t.action
    };
  }
}
export {
  m as RedsysPaymentProcess
};
//# sourceMappingURL=redsys.process.js.map
